import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

export const POST_REQUEST_VERIFY_PHONE = 'EMPLOYEE/POST_REQUEST_VERIFY_PHONE'

const apiCall = enhancedMakeFetchAction(POST_REQUEST_VERIFY_PHONE, payload => ({
  endpoint: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/account/send-phone-verification-code`,
  method: 'POST',
  body: payload,
  notify: true,
  isStay: true
}))

export default apiCall
